import { useDispatch, useSelector } from "react-redux";
import {
  Drawer,
  Text,
} from "@chakra-ui/react";

//   actions

import { resetDrawer } from "../../../../store/actions/miscAction";
// components
import SubscriptionForm from "../Form/SubscriptionForm";
import { resetForm } from "../../../../store/actions/subscriptionsActions";
import ReportForm from "../Form/ReportForm";
import PastReportsForm from "../Form/PastReportsForm";

function DrawerComponent(props) {
  const dispatch = useDispatch();

  const { drawer } = useSelector((state) => state.miscReducer);
  const { title, content, isOpen } = drawer;

  const onClose = () => {
    dispatch(resetDrawer());
    dispatch(resetForm());
  };

  const Components = {
    SubscriptionForm: <SubscriptionForm id={content.id} />,
    ReportForm: <ReportForm />,
    PastReportsForm: <PastReportsForm />,
  };

  return (
    <Drawer.Root open={Boolean(isOpen)} onOpenChange={onClose} placement="end" size="sm">
      <Drawer.Backdrop />
      <Drawer.Positioner>
        <Drawer.Content display="flex" flexDirection="column" height="100vh" maxH="100vh">
          <Drawer.CloseTrigger position="absolute" top="16px" right="16px" />
          <Drawer.Header mt="50px" flexShrink={0}>
            <Drawer.Title>
              <Text fontSize="24px" fontWeight={400} color="var(--black)">
                {title}
              </Text>
            </Drawer.Title>
          </Drawer.Header>
          <Drawer.Body
            overflowY="scroll"
            flex="1"
            pb="24px"
            sx={{
              '&::-webkit-scrollbar': {
                width: '8px',
              },
              '&::-webkit-scrollbar-track': {
                background: '#f1f1f1',
                borderRadius: '4px',
              },
              '&::-webkit-scrollbar-thumb': {
                background: '#c1c1c1',
                borderRadius: '4px',
              },
              '&::-webkit-scrollbar-thumb:hover': {
                background: '#a1a1a1',
              },
            }}
          >
            {Components[content.component]}
          </Drawer.Body>
        </Drawer.Content>
      </Drawer.Positioner>
    </Drawer.Root>
  );
}

export default DrawerComponent;
